/**
 * Thin progress strip the Viewer shows while the data layer is fetching
 * a big chunk (currently: per-instance DICOMweb metadata for a freshly
 * opened series). Pulls state from the dataProgress Zustand store; the
 * fetcher decides when to start/bump/done, this component just renders.
 */
import { useDataProgress } from '../stores/dataProgress';
import styles from './DataProgressBanner.module.css';

export default function DataProgressBanner() {
  const active = useDataProgress((s) => s.active);
  const label  = useDataProgress((s) => s.label);
  const loaded = useDataProgress((s) => s.loaded);
  const total  = useDataProgress((s) => s.total);

  if (!active) return null;

  const pct = total > 0 ? Math.min(100, Math.round((loaded / total) * 100)) : 0;

  return (
    <div className={styles.bar}>
      <div className={styles.fill} style={{ width: `${pct}%` }} />
      <div className={styles.text}>
        <span className={styles.label}>{label || 'Loading…'}</span>
        {total > 0 && (
          <span className={styles.counts}>
            {loaded.toLocaleString()} / {total.toLocaleString()}
            {' '}
            <span className={styles.pct}>({pct}%)</span>
          </span>
        )}
      </div>
    </div>
  );
}
